import React, { useState, useEffect } from "react";
import {
  Modal,
  Header,
  Image,
  Popup,
  Container,
  Card,
} from "semantic-ui-react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteDocumentUser } from "../../actions/dataConsoleAction";
import Loader from "../../components/Loader";
import moment from "moment";

const DatasetDetailsUsers = ({
  columns,
  data,
  loaderFlag,
  setDeleteuserDataFlag,
}) => {
  const dispatch = useDispatch();
  const { datasetId, datasetNameParam } = useParams();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(
    parseInt(`${process.env.REACT_APP_ROWSPERPAGE}`)
  );
  const [openDeleteBox, setopenDeleteBox] = useState(false);
  const [DeleteuserData, setDeleteuserData] = useState("");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleClose = () => {
    setopenDeleteBox(false);
  };

  const handleDelete = async (data) => {
    setopenDeleteBox(true);
    setDeleteuserData(data);
  };

  const deleteUserData = async () => {
    try {
      setDeleteuserDataFlag(true);
      setopenDeleteBox(false);
      dispatch(deleteDocumentUser(datasetId, DeleteuserData.id));
    } catch (error) {
      console.error("Error deleting data:", error);
    }
  };

  const getTimeAgo = (createdUTC) => {
    const today = moment().startOf("day");
    const createdDate = moment.utc(createdUTC).local().startOf("day");

    const timeDifference = today.diff(createdDate, "days");

    if (timeDifference === 0) {
      return "Updated today";
    } else if (timeDifference === 1) {
      return "Updated yesterday";
    } else {
      return `Updated ${timeDifference} days ago`;
    }
  };

  const totalItems = data.length;

  const UserCard = ({ username, mail, onDelete, createdUTC  , displayName}) => {
    return (
      <Card fluid className="qac-card">
        <Card.Content>
          <Card.Meta>
            <div className="mobile-dataconsole-user-card">
              <div className="nameEmailMobile">
                <p>{username} </p>
                <p>{mail}</p>
              </div>
            </div>
          </Card.Meta>
        </Card.Content>
        <Card.Content
          extra
          className="dataconsole-users-footer qac-card-extra-content"
        >
          <div
            className="dataconsole-user-actions-delete mobile-dataconsole-actions"
            onClick={onDelete}
          >
            <div className="dataconsole-user-last-updated">
            {getTimeAgo(createdUTC)} {displayName}
            </div>
            <div className="mobile-dataconsole-actions">
              <div className="user-card-icons grey-icons">
                <div>
                  <img
                    className="tableButton"
                    src="/images/grey-circle.svg"
                    alt="Delete"
                    style={{ cursor: "pointer" }}
                    data-cy="dataset-delete-link"
                  />
                </div>
              </div>
              <div className="user-card-icons color-icons">
                <div>
                  <img
                    className="tableButton"
                    src="/images/red-circle-delete.svg"
                    alt="Delete"
                    style={{ cursor: "pointer" }}
                    data-cy="dataset-delete-link"
                  />
                </div>
              </div>
            </div>
          </div>
        </Card.Content>
      </Card>
    );
  };

  return (
    <>
      {loaderFlag && <Loader />}
      <Container>
        <Card.Group itemsPerRow={3} stackable>
          {data.length > 0
            ? data.map((row) => (
                <UserCard
                  username={row.displayName}
                  createdUTC={row.createdUTC}
                  mail={
                    row.email.length < 30 ? (
                      row.email
                    ) : (
                      <Popup
                        content={row.email}
                        inverted
                        position="right center"
                        style={{ borderRadius: "15px" }}
                        trigger={<span>{row.email.slice(0, 30)}..</span>}
                      />
                    )
                  }
                  displayName={row.displayName}
                  onDelete={() => handleDelete(row)}
                  className="mobile-document-tab"
                />
              ))
            : ""}
        </Card.Group>
      </Container>

      <Modal
        open={openDeleteBox}
        onClose={handleClose}
        size="tiny"
        className="add-document-model deletePopup"
      >
        <Modal.Content>
          <Header as="h3">Remove User</Header>
          <p>Are you sure you want to remove "{DeleteuserData.userName}"</p>
        </Modal.Content>
        <Modal.Actions>
          <button
            className="cancel-btn"
            onClick={handleClose}
            data-cy="cancel-remove-user-cy"
          >
            Cancel
          </button>
          <button
            className="add-btn"
            onClick={deleteUserData}
            data-cy="remove-remove-user-cy"
          >
            Remove
          </button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default DatasetDetailsUsers;
